export default function Services() {
  const services = [
    {
      icon: 'ri-shield-check-line',
      title: 'Sécurité',
      description: 'Apprenez les techniques essentielles de sécurité en montagne, la gestion des risques d\'avalanche, l\'utilisation du matériel de sécurité (DVA, pelle, sonde) et les bonnes pratiques pour évoluer en toute sécurité hors-piste. Nos moniteurs certifiés vous transmettent leur expertise pour que vous puissiez profiter de la montagne en toute confiance.',
      image: 'https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/cea5335e76000b7de20b20eb08c04d1a.png'
    },
    {
      icon: 'ri-mountain-line',
      title: 'Freeride',
      description: 'Explorez les pentes vierges et la poudreuse avec nos cours de freeride adaptés à tous les niveaux. Découvrez les meilleurs spots d\'Orelle et des Trois Vallées, perfectionnez votre technique en hors-piste, apprenez à lire le terrain et à choisir vos trajectoires. Profitez d\'une neige d\'exception de début décembre à fin avril pour vivre l\'expérience ultime du ski en montagne avec des moniteurs passionnés.',
      image: 'https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/b497b667369f628590463e0bcfa73274.png'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Freestyle',
      description: 'Maîtrisez l\'art du freestyle dans notre snowpark accessible de début décembre à fin avril. Apprenez les sauts, les rotations, les grabs et les tricks sur modules adaptés à votre niveau. Que vous débutiez ou que vous visiez la compétition, nos moniteurs experts en freestyle vous accompagnent dans votre progression avec des exercices ludiques et techniques pour développer votre style et votre créativité sur les skis.',
      image: 'https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/355e9032e78406903a76a78f5cd0b473.png'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Préparation Physique',
      description: 'Préparez-vous aux compétitions avec notre programme de préparation physique et technique spécialement conçu pour les skieurs ambitieux. Renforcement musculaire, travail de l\'équilibre, amélioration de la condition physique, analyse vidéo de votre technique, stratégies de course et mental de compétiteur. Nos entraîneurs vous accompagnent pour atteindre vos objectifs sportifs et performer lors de vos compétitions.',
      image: 'https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/3d0d50b40d91748ba24347744a95fd56.png'
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h3 className="text-5xl md:text-6xl font-black text-black mb-6 tracking-tight uppercase">
            Nos Services
          </h3>
          <div className="w-24 h-1 bg-black mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-light">
            Des cours adaptés à tous les niveaux pour progresser en sécurité et atteindre vos objectifs
          </p>
        </div>

        <div className="bg-black text-white p-8 mb-12 border-4 border-black">
          <div className="max-w-4xl mx-auto text-center">
            <div className="flex items-center justify-center mb-4">
              <i className="ri-snowy-line text-5xl mr-4"></i>
              <h4 className="text-3xl font-black uppercase tracking-tight">Snowpark & Neige d'Exception</h4>
            </div>
            <p className="text-xl text-gray-300 font-light leading-relaxed">
              Profitez de notre <strong className="text-white">accès snowpark de début décembre jusqu'à fin avril</strong> avec une <strong className="text-white">neige d'exception garantie pendant toute cette période</strong>. Des conditions idéales pour progresser et s'amuser tout au long de la saison !
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white border-2 border-black overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="h-64 overflow-hidden">
                <img 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8 bg-black text-white">
                <div className="flex items-center mb-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-white text-black mr-4">
                    <i className={`${service.icon} text-3xl`}></i>
                  </div>
                  <h4 className="text-3xl font-black tracking-tight uppercase">
                    {service.title}
                  </h4>
                </div>
                <p className="text-gray-300 leading-relaxed font-light">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}